import { atom } from 'recoil';

export const toggleQuickConfig = atom({
    key: 'day2-paas-toggleQuickConfig',
    default: false,
});

export const quickConfigDetails = atom({
    key: 'day2-paas-quickConfigDetails',
    default: undefined,
});
export const toggleSspModels = atom({
    key: 'day2-paas-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSkuModalOpen: false,
        isStorageDiskModalOpen: false,
        isConfirmDeleteModalOpen: false,
        isConfigTagsModalOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
    },
});

export const isEnvDetailsLoading = atom({
    key: 'day2-paas-isEnvDetailsLoading',
    default: false,
});

export const isMandatoryTagsFullfilled = atom({
    key: 'day2-paas-isMandatoryTagsFullfilled',
    default: false,
});

export const orderId = atom({
    key: 'day2-paas-orderId',
    default: '',
});

export const sspSubmitOrder = atom({
    key: 'day2-paas-sspOrder',
    default: {
        appProfile: null,
        entityDetails: null,
        sector: null,
        sectorDetails: null,
        region: null,
        regionDisplayName: null,
        environment: null,
        hoursOfOperation: null,
        hoursOfOperationDetail: null,
        hCode: null,
        hCodeDetails: null,
        billingEntity: null,
        billingEntityDetails: null,
        tags: [],
        estimatedCost: null,
        cloudProvider: 'Azure',
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
        projectName: null,
        projectNameDetail: null,
        notes: null,
        serverName: null,
        serverNameDetail: null,
        modificationType: null,
        modificationTypeDetail: null,
        currentSku: null,
        configureNewSku: null,
        configureNewSkuDetail: null,
        modifyTags: [],
        maxModifyTagsCount: 5,
        enableKeyRotation: 'Yes',
    },
});

export const environmentDetails = atom({
    key: 'day2-paas-environmentDetails',
    default: {
        Subscription: '---',
        'DR Priority': '---',
        Resource_Group: '---',
        Metallic_Selection: '---',
        Backup_Tier: '---',
        Virtual_Network: '---',
        Subnet_Name: '---',
        Recovery_Vault_Name: '---',
        Approval_Manager: '---',
        Project: '---',
        Availability_Set: '---',
        Azure_Site_Recovery: '---',
    },
});

export const costEstimateState = atom({
    key: 'day2-paas-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'day2-paas-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});
export const isValidNotes = atom({
    key: 'day2-paas-isValidNotes',
    default: false,
});
export const isSkuConfigFullfilled = atom({
    key: 'day2-paas-isSkuConfigFullfilled',
    default: false,
});
export const isStorageDiskConfigFullfilled = atom({
    key: 'day2-paas-isStorageDiskConfigFullfilled',
    default: false,
});
export const isDataDiskConfigFullfilled = atom({
    key: 'day2-paas-isDataDiskConfigFullfilled',
    default: false,
});
export const isConfigureTagsFullfilled = atom({
    key: 'day2-paas-isConfigureTagsFullfilled',
    default: false,
});
